import {IBridge} from "@kta20-core/bridge-manager";
import {IUiBaseBridge} from "@kta20-ui-base/interfaces/i-ui-base-bridge";
import {IUiServices} from "@kta20-core/interfaces/i-ui-services";
import {INavigationManager} from "@kta20-core/interfaces/i-navigation-manager";

export class UiBaseBridge implements IBridge, IUiBaseBridge {

    _uiService: IUiServices;
    _navManager:INavigationManager;

    get uiService(): IUiServices {
        return this._uiService;
    }

    get navigationManager(): INavigationManager {
        return this._navManager;
    }

    static factory(uiServices:IUiServices,navManager:INavigationManager): IBridge {
        const br = new UiBaseBridge();
        br._uiService = uiServices;
        br._navManager = navManager;
        return br;
    };

}
